import * as angular from "angular";
import entitySchemaTab from "../entity-schema-tab";
import {
	jsonPointerToSchemaFormPath,
	validateEntitySchemaModel
} from "../entitySchemaValidation";
import template from "./entity-schema-editor.html";

const CUSTOM_SCHEMA_ERROR = "schema";

export function controller($scope, $logger) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.isLoading = false;
		ctrl.handleFieldChange = clearChangedFieldSchemaError;
		syncState();
	};
	ctrl.$onChanges = onChanges;
	ctrl.beginEditing = beginEditing;
	ctrl.handleSubmit = handleSubmit;
	ctrl.isDirty = isDirty;
	ctrl.leaveEditing = leaveEditing;
	ctrl.save = saveChanges;
	ctrl.saveChanges = saveChanges;

	function onChanges(changes) {
		const modelChange = changes.model;
		if(!modelChange || modelChange.isFirstChange() || isDirty()) {
			return;
		}

		syncState(modelChange.currentValue);
	}

	function beginEditing() {
		if(ctrl.readonly) {
			return false;
		}

		syncState();
		return true;
	}

	function leaveEditing() {
		clearSchemaValidation();
		ctrl.editModel = angular.copy(ctrl.editSnapshot);
		return true;
	}

	function isDirty() {
		return !angular.equals(ctrl.editModel, ctrl.editSnapshot);
	}

	function handleSubmit() {
		const saveAction = ctrl.section.activeActions
			.find(action => action.code === "save");

		return saveAction
			? ctrl.section.invokeAction(saveAction)
			: false;
	}

	async function saveChanges() {
		if(ctrl.readonly) {
			return false;
		}
		if(!isDirty()) {
			return true;
		}

		clearSchemaValidation();
		$scope.$broadcast("schemaFormValidate");
		const schemaValidation = validateEntitySchemaModel(ctrl.editModel, ctrl.schema);
		ctrl.schemaFieldErrors = schemaValidation.fieldErrors;
		applySchemaFieldErrors();

		if(ctrl.schemaForm?.$invalid || !schemaValidation.valid) {
			return false;
		}

		ctrl.isLoading = true;
		try {
			await ctrl.onSave({ model: angular.copy(ctrl.editModel) });
			ctrl.model = angular.copy(ctrl.editModel);
			ctrl.editSnapshot = angular.copy(ctrl.editModel);
			return true;
		}
		catch(error) {
			$logger.error("entity schema update error", error);
			throw error;
		}
		finally {
			ctrl.isLoading = false;
		}
	}

	function syncState(model = ctrl.model) {
		clearSchemaValidation();
		ctrl.editModel = angular.copy(model ?? {});
		ctrl.editSnapshot = angular.copy(ctrl.editModel);
	}

	function applySchemaFieldErrors() {
		Object.entries(ctrl.schemaFieldErrors).forEach(([path, message]) => {
			$scope.$broadcast(
				`schemaForm.error.${jsonPointerToSchemaFormPath(path)}`,
				CUSTOM_SCHEMA_ERROR,
				message,
				false
			);
		});
	}

	function clearChangedFieldSchemaError(_, form) {
		const changedPath = form?.key?.join?.(".");
		if(!changedPath) {
			return;
		}

		const pathsToClear = Object.keys(ctrl.schemaFieldErrors ?? {})
			.filter(path => {
				const schemaFormPath = jsonPointerToSchemaFormPath(path);
				return schemaFormPath === changedPath
					|| schemaFormPath.startsWith(`${changedPath}.`)
					|| changedPath.startsWith(`${schemaFormPath}.`);
			});

		pathsToClear.forEach(path => clearSchemaFieldError(path));
	}

	function clearSchemaFieldError(path) {
		$scope.$broadcast(
			`schemaForm.error.${jsonPointerToSchemaFormPath(path)}`,
			CUSTOM_SCHEMA_ERROR,
			true
		);
		delete ctrl.schemaFieldErrors[path];
	}

	function clearSchemaValidation() {
		Object.keys(ctrl.schemaFieldErrors ?? {}).forEach(clearSchemaFieldError);
		ctrl.schemaFieldErrors = {};
	}
}

export default angular
	.module("vesl.components.entity-schema-editor", [entitySchemaTab])
	.component("entitySchemaEditor", {
		controller,
		template,
		bindings: {
			actionLabel: "<",
			schema: "<",
			sectionKey: "<",
			model: "=",
			readonly: "<",
			onSave: "&"
		},
		require: {
			section: "^^viewModesSection"
		}
	})
	.name;
